import React from 'react';
import * as Collapsible from '@radix-ui/react-collapsible';
import I18n from '@/modules/i18n';
import CaretButton from '@/components/common/libraries/common/CaretButton';

interface RowChevronProps {
  expanded: boolean;
  label: string;
  onToggle: () => void;
}

// The caret on a row inside the standards tree or the unit/lesson list. Everything visual lives in
// CaretButton, shared with the library filter panels; this only adds the Radix trigger and names
// the row it belongs to, so a screen reader hears which row it would expand.
const RowChevron = ({ expanded, label, onToggle }: RowChevronProps) => (
  <Collapsible.Trigger asChild>
    <CaretButton
      aria-label={`${expanded ? I18n.t('collapse') : I18n.t('expand')} ${label}`}
      expanded={expanded}
      size={12}
      onClick={onToggle}
    />
  </Collapsible.Trigger>
);

export default RowChevron;
